module.exports = __webpack_public_path__ + "img/P2-A9.31b17fcf.svg";